var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgPatientBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FEF7F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1331 21.0596C22.0498 21.0513 21.9498 21.0513 21.8581 21.0596C19.8748 20.993 18.2998 19.368 18.2998 17.368C18.2998 15.3263 19.9498 13.668 21.9998 13.668C24.0415 13.668 25.6998 15.3263 25.6998 17.368C25.6915 19.368 24.1165 20.993 22.1331 21.0596Z",
    stroke: "#EFAE78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9666 24.132C15.9499 25.482 15.9499 27.682 17.9666 29.0237C20.2583 30.557 24.0166 30.557 26.3083 29.0237C28.3249 27.6737 28.3249 25.4737 26.3083 24.132C24.0249 22.607 20.2666 22.607 17.9666 24.132Z",
    stroke: "#EFAE78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgPatientBg);
export default __webpack_public_path__ + "static/media/orgPatientBG.ff3a31e3c57e94e4fb4764ced0fe36d7.svg";
export { ForwardRef as ReactComponent };